import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    listOfStates: [
      { name: "Alabama",  propName: "alabama" },
      { name: "Alaska",  propName: "alaska" },
      { name: "Arizona",  propName: "arizona" },
      { name: "Arkansas",  propName: "arkansas" },
      { name: "California",  propName: "california" },
      { name: "Colorado",  propName: "colorado" },
      { name: "Connecticut",  propName: "connecticut" },
      { name: "Delaware",  propName: "delaware" },
      { name: "District of Columbia",  propName: "district_of_columbia" },
      { name: "Florida",  propName: "florida" },
      { name: "Georgia",  propName: "georgia" },
      { name: "Guam",  propName: "guam" },
      { name: "Hawaii",  propName: "hawaii" },
      { name: "Idaho",  propName: "idaho" },
      { name: "Illinois",  propName: "illionois" },
      { name: "Indiana",  propName: "indiana" },
      { name: "Iowa",  propName: "iowa" },
      { name: "Kansas",  propName: "kansas" },
      { name: "Kentucky",  propName: "kentucky" },
      { name: "Louisiana",  propName: "louisiana" },
      { name: "Maine",  propName: "maine" },
      { name: "Maryland",  propName: "maryland" },
      { name: "Massachusetts",  propName: "massachusetts" },
      { name: "Michigan",  propName: "michigan" },
      { name: "Minnesota",  propName: "minnesota" },
      { name: "Mississippi",  propName: "mississippi" },
      { name: "Missouri",  propName: "missouri" },
      { name: "Montana",  propName: "montana" },
      { name: "Nebraska",  propName: "nebraska" },
      { name: "Nevada",  propName: "nevada" },
      { name: "New Hampshire",  propName: "new_hampshire" },
      { name: "New Jersey",  propName: "new_jersey" },
      { name: "New Mexico",  propName: "new_mexico" },
      { name: "New York",  propName: "new_york" },
      { name: "North Carolina",  propName: "north_carolina" },
      { name: "North Dakota",  propName: "north_dakota" },
      { name: "Northern Mariana Islands",  propName: "northern_mariana_islands" },
      { name: "Ohio",  propName: "ohio" },
      { name: "Oklahoma",  propName: "oklahoma" },
      { name: "Oregon",  propName: "oregon" },
      { name: "Pennsylvania",  propName: "pennsylvania" },
      { name: "Puerto Rico",  propName: "puerto_rico" },
      { name: "Rhode Island",  propName: "rhode_island" },
      { name: "South Carolina",  propName: "south_carolina" },
      { name: "South Dakota",  propName: "south_dakota" },
      { name: "Tennessee",  propName: "tennessee" },
      { name: "Texas",  propName: "texas" },
      { name: "Utah",  propName: "utah" },
      { name: "Vermont",  propName: "vermont" },
      { name: "Virgin Islands",  propName: "virgin_islands" },
      { name: "Virginia",  propName: "virginia" },
      { name: "Washington",  propName: "washington" },
      { name: "West Virginia",  propName: "west_virginia" },
      { name: "Wisconsin",  propName: "wisconsin" },
      { name: "Wyoming",  propName: "wyoming" },
    ],
    covidData: {},
    navDrawer: true
  },
  mutations: {
    saveCovidData(state, data) {
      state.covidData = data
    },
    setNavDrawer(state, val) {
      state.navDrawer = val
    },
    toggleNavDrawer(state) {
      state.navDrawer = !state.navDrawer
    },
  },
  getters: {
    getNavDrawer(state) {
      return state.navDrawer
    },
    getListOfStates(state) {
      return state.listOfStates
    },
    getCovidData(state) {
      return state.covidData
    },
  },
  actions: {
  },
  modules: {
  }
})
